import { Alert, Badge, Divider, Flex, Tag, Typography } from "antd";

import { COMPANY_ROLES, COMPANY_STATUS_ENUM, COMPANY_STATUSES, COMPANY_TYPES, CompanyEntity } from "interfaces";
import { dateFormat } from "utils";
import { Status } from "ui";
import { SAFE_DEAL, DIRECT_PAYMENT_CUSTOMER_LP } from "utils/envConstants";
import { UserStore } from "stores/UserStore";
import { CreateBeneficiaryButton } from "../CreateBeneficiaryBtn";
import { observer } from "mobx-react-lite";

const BeneficiaryStatus = ({ beneficiaryCreated }: { beneficiaryCreated: boolean }) => {
  if (!SAFE_DEAL) return null;

  return (
    <Alert
      message={
        beneficiaryCreated ? (
          "Бенефициар зарегистрирован"
        ) : (
          <Flex justify="space-between" gap="large">
            <Typography.Text>Бенефициар не зарегистрирован</Typography.Text>
            <CreateBeneficiaryButton />
          </Flex>
        )
      }
      type={beneficiaryCreated ? "success" : "error"}
      showIcon
      style={{ width: "fit-content" }}
    />
  );
};

export const CompanyHeader = observer(({ data, user }: { data: CompanyEntity; user: UserStore }) => {
  const { companyName, companyRegistrationNumber, role, createdAt, statusDate, status, inn, kpp, type } = data;
  const { beneficiaryCreated } = data;
  const { isSeniorOperator, isJuniorOperator, isUserAdmin } = user.roles;
  const isOperatorRole = isSeniorOperator || isJuniorOperator || isUserAdmin;

  const showBeneficiaryStatus =
    !DIRECT_PAYMENT_CUSTOMER_LP && isOperatorRole && SAFE_DEAL && data.status === COMPANY_STATUS_ENUM.ACTIVE;

  return (
    <div>
      <Typography.Title style={{ marginBottom: "4px" }}>{companyName}</Typography.Title>

      <Flex justify="space-between" align="center">
        <Flex vertical gap="small">
          <Flex gap="small" align="center">
            <Typography.Text strong className="text-uppercase link-color">
              {COMPANY_ROLES.texts[role]}
            </Typography.Text>

            <Typography.Text type="secondary">Дата регистрации: {dateFormat(createdAt)}</Typography.Text>
          </Flex>
          {showBeneficiaryStatus && <BeneficiaryStatus beneficiaryCreated={beneficiaryCreated} />}
        </Flex>
        <Flex>
          <Status color={COMPANY_STATUSES.colors[status]} tooltip={`Обновлен ${dateFormat(statusDate, true)}`}>
            {COMPANY_STATUSES.texts[status]}
          </Status>
        </Flex>
      </Flex>
    </div>
  );
});
